var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNaverBlogIcon = function SvgNaverBlogIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.454 7.908H10.537a3.069 3.069 0 0 0-3.06 3.06v7.408c0 1.687 1.379 3.06 3.06 3.06h4.208l.724 1.253.713 1.234a.337.337 0 0 0 .585 0l.713-1.234.725-1.253h4.254c1.687 0 3.06-1.379 3.06-3.06v-7.402a3.075 3.075 0 0 0-3.065-3.066Zm-5.124 5.426c-.922 0-1.67.736-1.67 1.646 0 .91.748 1.646 1.67 1.646.922 0 1.67-.736 1.67-1.646 0-.91-.743-1.646-1.67-1.646Zm0 2.434c-.44 0-.8-.354-.8-.788 0-.435.36-.789.8-.789.44 0 .8.354.8.789a.792.792 0 0 1-.8.788Zm-6.237-2.057c.26-.238.597-.377.956-.377.835 0 1.501.742 1.501 1.652 0 .91-.672 1.646-1.501 1.646-.365 0-.696-.145-.957-.377v.296h-.927v-4.202h.928v1.362Zm.005 1.594a.83.83 0 0 0 .765.498.825.825 0 0 0 .835-.823.825.825 0 0 0-.835-.823.83.83 0 0 0-.834.823c0 .116.029.226.07.325Zm10.792-1.901v.26a1.52 1.52 0 0 0-.933-.324c-.852 0-1.542.713-1.542 1.588 0 .875.69 1.588 1.542 1.588.354 0 .678-.122.933-.324v.44s-.093.435-.742.435v.817s.701.081 1.328-.545c0 0 .29-.307.353-.713v-3.222h-.939Zm-.76 2.33c-.469 0-.845-.366-.845-.812 0-.446.382-.811.846-.811.33 0 .62.185.76.452.057.11.086.232.086.36a.822.822 0 0 1-.087.359.846.846 0 0 1-.76.452Zm-7.476-2.626v-.84s.614-.082 1.16.561c0 0 .248.313.306.73v2.992h-.956v-2.968c-.081-.417-.51-.475-.51-.475Z",
    fill: "#424242"
  })));
};

export default SvgNaverBlogIcon;